module.exports = __webpack_public_path__ + "img/avatar-shader.20786225.svg";